import { getCustomFonts, resetCms } from '@app/ducks';
import { addAllTextStyleFonts, addCustomFonts, updateButtonStylesTag, updateTextStylesTag } from '@app/logic/cms/styles';
import { Cms } from '@typings';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useCustomStylesLoader = (textStyles: Record<string, Cms.TextStyle>, buttonStyles: Record<string, Cms.ButtonStyle>) => {
  const dispatch = useDispatch();
  const customFonts = useSelector(getCustomFonts);

  React.useEffect(() => {
    addCustomFonts(customFonts);
    addAllTextStyleFonts();

    return () => {
      dispatch(resetCms());
      // eslint-disable-next-line functional/immutable-data
      Object.assign(window, { name: undefined });
    };
  }, []);

  React.useEffect(() => {
    updateButtonStylesTag(buttonStyles);
  }, [buttonStyles]);

  React.useEffect(() => {
    updateTextStylesTag(textStyles);
  }, [textStyles]);
};
